import { Rating } from "@mui/material";

import { STYLES } from "./style/customStyles";

export default function CustomRating({value}){
    return(
        <Rating name="half-rating-read" defaultValue={value} precision={0.5} readOnly size="small" sx={STYLES.rating}/>
    )
}